import { RegMenReportsService } from "~/entity/RegMenReports/api/service";

import { useRegMenReportFileMutation } from "./useRegMenReportMutation";

export const useGetRegMenByPeriodReportFile = (onSuccess?: () => void) => {
  const { isLoading, isError, mutate } = useRegMenReportFileMutation(
    RegMenReportsService.POST.getRegMenByDealerByPeriodFile,
    onSuccess,
  );

  return {
    isLoading,
    isError,
    getRegMenByPeriodReportFile: mutate,
  };
};
